<template>
  <div>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-card>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </b-card>
      </template>
      <div>
        <div class="contentsCollapse d-flex flex-column">
          <div class="blockContentCollapse">
            <VmInfoCard :title="cardInfo.title">
              <b-dropdown
                class="actions-button mt-5 w-100"
                variant="light"
                :text="$t('global.actions')"
              >
                <b-dropdown-item @click="openStartAutoDiscovery"
                  >Start Auto Discovery</b-dropdown-item
                >
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="setNodePublic"
                  >Set this node public</b-dropdown-item
                >
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item
                  class="dropdownAlertLabel"
                  @click="openTerminateHandler"
                  >Delete Cloud Node</b-dropdown-item
                >
              </b-dropdown>
            </VmInfoCard>
            <div
              class="vm-buttons blockContentArea d-flex flex-column justify-content-center"
            >
              <div class="buttons-area">
                <div class="title">
                  {{ $t('detail.serverOperations') }}
                </div>
                <ServerActionButton
                  class="button danger"
                  @click.native="changeMaintenanceMode"
                >
                  Maintenance
                </ServerActionButton>
                <ServerActionButton
                  class="button primary"
                  @click.native="addServer"
                >
                  <i class="fas fa-server"></i>
                  Add Server
                </ServerActionButton>
                <!-- <ServerActionButton class="button primary">
                  <i class="fas fa-hdd"></i>
                  Add NFS Volume
                </ServerActionButton>
                <ServerActionButton class="button primary">
                  <i class="fas fa-hdd"></i>
                  Add iSCSI Volume
                </ServerActionButton> -->
                <ServerActionButton
                  class="button primary"
                  @click.native="addNetworkDevice"
                >
                  <i class="fas fa-network-wired"></i>
                  Add Network Device
                </ServerActionButton>
              </div>
            </div>
            <KeyValueList :items="keyValue" />
            <!-- <ChartList :items="charts" /> -->
          </div>
        </div>

        <FullWidthList
          class="mt-10"
          :mainHeader="mainHeaderList"
          :subHeader="subHeaderList"
          :items="itemList"
        />
      </div>
    </b-skeleton-wrapper>

    <DeleteOperation :url="deleteOperationUrl" @updateList="redirectList" />

    <!-- Create Popup -->
    <DetailModal
      :title="$t(dynamicOperationComponentTitle)"
      :show="showDetail"
      @confirm="confirmModal()"
      @closeDetail="closeDetail()"
      :resetForm="resetForm"
      :confirmLabel="confirmLabel"
    >
      <component
        v-if="dynamicOperationComponent != ''"
        :is="dynamicOperationComponent"
        :confirmModal="confirmCreate"
        @resetDetailForm="resetDetailForm"
        :detailData="detailData"
      />
    </DetailModal>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service'
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'

export default {
  name: 'CloudNodeDetail',
  data() {
    return {
      loading: false,
      detailData: '',
      keyValue: [],
      cardInfo: {
        title: '',
      },
      charts: [],
      mainHeaderList: [],
      subHeaderList: [],
      itemList: [],
      deleteOperationUrl: '',
      dynamicOperationComponentTitle: '',
      dynamicOperationComponent: '',
      showDetail: false,
      confirmCreate: false,
      resetForm: false,
      confirmLabel: '',
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'servers.cloudNodes', route: '/my-cloud/cloud-nodes' },
    ])
    this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
      menuList: [
        { title: 'servers.myCloud', route: '/my-cloud/cloud-nodes' },
        {
          title: 'servers.cloudNodes',
          route: '/my-cloud/cloud-nodes',
        },
        { title: 'global.detail' },
      ],
      showSearch: false,
      showDetailButton: false,
    })
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.loading = true
      this.getDetailInfo()
        .then((res) => {
          this.setDetailInfo(res)
        })
        .catch(() => {
          this.redirectList()
        })
    },
    getDetailInfo() {
      return new Promise((resolve, reject) => {
        ApiService.get(
          `iaas/datacenter-nodes/${this.$route.params.id}?include=product,computePool,storageVolumes.product,proxyServer,dhcpServer,natServer&withInvisibleProduct`
        )
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    setDetailInfo(res) {
      if (res && res.data) {
        this.detailData = res.data
        this.setInfoCard()
        this.setKeyValueList()
        this.setChartList()
        this.setTabs()
        this.loading = false
      } else {
        this.redirectList()
      }
    },
    setInfoCard() {
      this.cardInfo = {
        title: this.detailData.name,
      }
    },
    setKeyValueList() {
      this.keyValue = [
        {
          keyGlobal: 'detail.cloudNode.nodeType',
          value:
            this.detailData.computePool &&
            this.detailData.computePool.data.length > 0
              ? this.detailData.computePool.data.pool_type
              : '',
        },
        {
          keyGlobal: 'detail.cloudNode.virtualization',
          value:
            this.detailData.computePool &&
            this.detailData.computePool.data.length > 0
              ? this.detailData.computePool.data.virtualization
              : '',
        },
        {
          keyGlobal: 'detail.cloudNode.virtualizationVersion',
          value:
            this.detailData.computePool &&
            this.detailData.computePool.data.length > 0
              ? this.detailData.computePool.data.virtualization_version
              : '',
        },
        {
          keyGlobal: 'detail.cloudNode.minCPULimit',
          value: this.detailData.min_cpu_limit
            ? this.detailData.min_cpu_limit
            : '',
        },
        {
          keyGlobal: 'detail.cloudNode.maxCPULimit',
          value: this.detailData.max_cpu_limit
            ? this.detailData.max_cpu_limit
            : '',
        },
        {
          keyGlobal: 'detail.cloudNode.minRAMLimit',
          value: `${this.$customFunctions.convertMBtoGBWithHalfPoint(
            this.detailData.min_ram_limit
          )} GB`,
        },
        {
          keyGlobal: 'detail.cloudNode.maxRAMLimit',
          value: `${this.$customFunctions.convertMBtoGBWithHalfPoint(
            this.detailData.max_ram_limit
          )} GB`,
        },
        {
          keyGlobal: 'detail.cloudNode.isPublic',
          valueGlobal: this.detailData.is_public ? 'global.yes' : 'global.no',
        },
        {
          keyGlobal: 'detail.cloudNode.isEdge',
          valueGlobal: this.detailData.is_edge ? 'global.yes' : 'global.no',
        },
      ]
    },
    setChartList() {
      this.charts = [{ name: 'AGILE INDEX', value: 0 }]
      this.getCPUChart()
      this.getRAMChart()
      this.getNetworkChart()
      this.getVolumeChart()
    },
    //charts:begin
    getCPUChart() {
      this.charts.push({
        name: 'CPU',
        value: 0,
      })
    },
    getRAMChart() {
      this.charts.push({
        name: 'RAM',
        value: 0,
      })
    },
    getNetworkChart() {
      this.charts.push({
        name: 'NETWORK',
        value: 0,
      })
    },
    getVolumeChart() {
      this.charts.push({
        name: 'VOLUME',
        value: 0,
      })
    },
    //charts:end
    setTabs() {
      this.mainHeaderList = [
        { id: 'computeManagement', name: 'Compute Management' },
        { id: 'storageManagement', name: 'Storage Management' },
        { id: 'networkManagement', name: 'Network Management' },
        { id: 'nfvOptions', name: 'NFV Options' },
      ]
      this.subHeaderList = [
        // Compute Management
        {
          id: 'computeMembers',
          mainId: 'computeManagement',
          name: 'Compute Members',
        },
        {
          id: 'computePool',
          mainId: 'computeManagement',
          name: 'Compute Pool',
        },
        //Storage Management
        {
          id: 'storageMembers',
          mainId: 'storageManagement',
          name: 'Storage Members',
        },
        {
          id: 'storageVolumes',
          mainId: 'storageManagement',
          name: 'Storage Volumes',
        },
        {
          id: 'storagePool',
          mainId: 'storageManagement',
          name: 'Storage Pool',
        },
        // Network Management
        {
          id: 'networkMembers',
          mainId: 'networkManagement',
          name: 'Network Members',
        },
        {
          id: 'networks',
          mainId: 'networkManagement',
          name: 'Networks',
        },
        {
          id: 'networkPool',
          mainId: 'networkManagement',
          name: 'Network Pool',
        },
        {
          id: 'ipAddresses',
          mainId: 'networkManagement',
          name: 'IP Addresses',
        },
        // NFV Options
        {
          id: 'dhcp',
          mainId: 'nfvOptions',
          name: 'DHCP',
        },
        {
          id: 'nat',
          mainId: 'nfvOptions',
          name: 'NAT',
        },
        {
          id: 'proxy',
          mainId: 'nfvOptions',
          name: 'Proxy',
        },
        {
          id: 'dns',
          mainId: 'nfvOptions',
          name: 'DNS',
        },
      ]
      this.itemList = [
        // Compute Management
        {
          mainId: 'computeManagement',
          subId: 'computeMembers',
          componentName: 'ComputeMembers',
        },
        {
          mainId: 'computeManagement',
          subId: 'computePool',
          componentName: 'ComputePool',
        },
        //Storage Management
        {
          mainId: 'storageManagement',
          subId: 'storageMembers',
          componentName: 'StorageMembers',
        },
        {
          mainId: 'storageManagement',
          subId: 'storageVolumes',
          componentName: 'StorageVolumes',
        },
        {
          mainId: 'storageManagement',
          subId: 'storagePool',
          componentName: 'StoragePool',
        },
        // Network Management
        {
          mainId: 'networkManagement',
          subId: 'networkMembers',
          componentName: 'NetworkMembers',
        },
        {
          mainId: 'networkManagement',
          subId: 'networks',
          componentName: 'Networks',
        },
        {
          mainId: 'networkManagement',
          subId: 'networkPool',
          componentName: 'NetworkPool',
        },
        {
          mainId: 'networkManagement',
          subId: 'ipAddresses',
          componentName: 'IPAddresses',
        },
        // NFV Options
        {
          mainId: 'nfvOptions',
          subId: 'dhcp',
          componentName: 'DHCP',
        },
        {
          mainId: 'nfvOptions',
          subId: 'nat',
          componentName: 'NAT',
        },
        {
          mainId: 'nfvOptions',
          subId: 'proxy',
          componentName: 'Proxy',
        },
        {
          mainId: 'nfvOptions',
          subId: 'dns',
          componentName: 'DNS',
        },
      ]
    },
    closeDetail() {
      this.showDetail = false
      this.dynamicOperationComponentTitle = ''
      this.dynamicOperationComponent = ''
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.$generateToast(this, 'success', this.$t('global.successful'))
        this.closeDetail()
        this.getDetail()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
    redirectList() {
      this.$router.push('/my-cloud/cloud-nodes')
    },
    openStartAutoDiscovery() {
      this.confirmLabel = 'global.save'
      this.dynamicOperationComponentTitle =
        'detail.cloudNode.startAutoDiscovery'
      this.dynamicOperationComponent = 'StartAutoDiscovery'
      this.showDetail = true
    },
    openTerminateHandler() {
      this.deleteOperationUrl = `iaas/datacenter-nodes/${this.$route.params.id}`
      this.$bvModal.show('modal-deleteOperation')
    },
    setNodePublic() {
      this.dynamicOperationComponentTitle = 'detail.cloudNode.setNodePublic'
      this.dynamicOperationComponent = 'SetNodePublic'
      this.confirmLabel = 'detail.cloudNode.makePubliclyAvailable'
      this.showDetail = true
    },
    changeMaintenanceMode() {
      this.dynamicOperationComponentTitle =
        'detail.cloudNode.changeMaintenanceMode'
      this.dynamicOperationComponent = 'ChangeMaintenanceMode'
      this.confirmLabel = 'detail.cloudNode.changeMaintenanceMode'
      this.showDetail = true
    },
    addServer() {
      this.dynamicOperationComponentTitle = 'detail.cloudNode.addServer'
      this.dynamicOperationComponent = 'AddServer'
      this.confirmLabel = 'global.save'
      this.showDetail = true
    },
    addNetworkDevice() {
      this.dynamicOperationComponentTitle = 'detail.cloudNode.addNetworkDevice'
      this.dynamicOperationComponent = 'AddNetworkDevice'
      this.confirmLabel = 'global.save'
      this.showDetail = true
    },
  },
  components: {
    // Components
    VmInfoCard: () => import('@/components/detail/VmInfoCard'),
    KeyValueList: () => import('@/components/detail/KeyValueList'),
    ChartList: () => import('@/components/detail/ChartList'),
    FullWidthList: () => import('@/components/detail/FullWidthList'),
    ServerActionButton: () => import('@/components/buttons/ServerActionButton'),
    //Popups
    StartAutoDiscovery: () =>
      import('@/components/cloudNode/forms/StartAutoDiscovery'),
    DeleteOperation: () => import('@/components/modals/DeleteOperation'),
    SetNodePublic: () => import('@/components/cloudNode/forms/SetNodePublic'),
    ChangeMaintenanceMode: () =>
      import('@/components/cloudNode/forms/ChangeMaintenanceMode'),
    AddServer: () => import('@/components/cloudNode/forms/AddServer'),
    AddNetworkDevice: () =>
      import('@/components/cloudNode/forms/AddNetworkDevice'),
  },
}
</script>

<style lang="scss" scoped>
.contentsCollapse {
  background: #ffffff;
  border-radius: 12px;
}
.blockContentCollapse {
  background: #ffffff;
  border-radius: 12px;
}
.vm-buttons {
  width: 275px;
  min-width: 200px;
  min-height: 260px;
  height: 100%;
  padding: 20px 10px 20px 20px;
  .buttons-area {
    background: #e1e9ff;
    border-radius: 12px;
    padding: 20px;
    .title {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 21px;
      color: #0a1f44;
      margin-bottom: 10px;
    }
    .button {
      margin-bottom: 10px;
      width: 100%;
      &:last-child {
        margin-bottom: 0;
      }
      .icon-down {
        transform: rotate(-180deg);
      }
    }
  }
}
</style>
